import React from "react";

import { Link } from "react-router-dom";

import img1 from "../../dashboard/components/img/post-icon-1.svg";
import img2 from "../../dashboard/components/img/post-icon-2.svg";

const data = [
	{
		img: img1,
		title: "Polkapet world",
		ico_price: "$0.005",
		current_price: "$0.009",
		ATH: "$0.014",
		link: "#",
		participants: "105",
		raised: "126,000",
		token_sold: "15,987,089",
		sale_ends: "Sept 14th 2024",
	},
	{
		img: img2,
		title: "Dexpools",
		ico_price: "$0.005",
		current_price: "$0.009",
		ATH: "$0.014",
		link: "#",
		participants: "105",
		raised: "126,000",
		token_sold: "15,987,089",
		sale_ends: "Sept 14th 2024",
	},
];

const PastSales = () => {
	return (
		<>
			<div className="container py-5">
				<div className="section-title">
					<h2 className="title">Past Sales</h2>
				</div>
				<div className="schedule-table-wrapper">
					<div className="wrapper p-3">
						{data && (
							<div className="table-responsive">
								<table className="table __sales-data-table m-0">
									<thead>
										<tr>
											<th className="__thead-th">Project Name</th>
											<th className="text-center __thead-th">
												ICO Token Price
											</th>
											<th className="text-center __thead-th">
												Current Price
											</th>
											<th className="text-center __thead-th">ATH</th>
											<th className="text-center __thead-th">
												No. Participants
											</th>
											<th className="text-center __thead-th">
												Total Raised (ALGO)
											</th>
											<th className="text-center __thead-th">
												Total Tokens Sold
											</th>
											<th className="text-center __thead-th">
												Sale Ends
											</th>
											<th className="text-center __thead-th">
												Action
											</th>
										</tr>
									</thead>
									<tbody>
										{data.map(
											(
												{
													img,
													title,
													link,
													ico_price,
													current_price,
													ATH,
													participants,
													raised,
													token_sold,
													sale_ends,
												},
												i
											) => (
												<tr key={i}>
													<td data-label="Project Name">
														<Link
															to={link}
															className="table-project __gap-6 mw-100"
														>
															<img src={img} alt="" />
															<h6 className="name">{title}</h6>
														</Link>
													</td>
													<td
														className="text-center"
														data-label="ICO Token Price"
													>
														<div>{ico_price}</div>
													</td>
													<td
														className="text-center"
														data-label="Current Price"
													>
														<div>{current_price}</div>
													</td>
													<td
														className="text-center"
														data-label="ATH"
													>
														<div>{ATH}</div>
													</td>
													<td
														className="text-center"
														data-label="No. Participants"
													>
														<div>{participants}</div>
													</td>
													<td
														className="text-center"
														data-label="Total Raised"
													>
														<div>{raised}</div>
													</td>
													<td
														className="text-center"
														data-label="Total Tokens Sold"
													>
														<div>{token_sold}</div>
													</td>
													<td
														className="text-center"
														data-label="Total Tokens Sold"
													>
														<div>{sale_ends}</div>
													</td>
													<td
														className="text-center"
														data-label="Total Tokens Sold"
													>
														<Link to="#" className="btn btn-base">
															View More
														</Link>
													</td>
												</tr>
											)
										)}
									</tbody>
								</table>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default PastSales;
